import { h } from 'preact';
import * as BaseComp from 'components/bolt/youtube/youtube.js';
// import s from 'components/bolt/youtube/youtube.sss';
import Store from 'store/store';

export default class Youtube extends BaseComp.default {

	getProgress() {
		if (!this.player?.getCurrentTime) {
			return;
		}
		const currentTime = this.player.getCurrentTime();
		const videoLength = this.player.getDuration();
		const progress = currentTime / videoLength;

		let step = [0, 25, 50, 75, 95, 100].find(step => progress >= (step / 100) && !this.progressTracking[step]);
		if (step || step === 0) {
			this.progressTracking[step] = true;
			const videoData = this.player.getVideoData();
			let percentage = Math.round(progress * 100) + '%';

			Store.emit('CUSTOM_EVENT', {
				category: this.props.activePage,
				action: 'videos-completion',
				label: percentage + '_' + videoData?.title + '_' + this.props.videoId,
			});


			// Store.emit('VIDEO_PLAYER_PROGRESS', {
			// 	platform: 'youtube',
			// 	video: this.props.videoId,
			// 	step,
			// 	time: currentTime,
			// 	videoLength,
			// 	isShowtimesMessage: this.props.isShowtimesMessage,
			// 	isTrailerOverlay: this.props.isTrailerOverlay,
			// 	isTrailer: this.props.isTrailer,
			// 	videoTitle: videoData?.title
			// });
		}

		if (typeof this.props.onProgress === 'function') {
			this.props.onProgress(progress, currentTime, videoLength);
		}
	}

}
